import SeriesMaterialsTab from './series-materials-tab'

export default SeriesMaterialsTab
